export const servicesQueryKey = '/admin/services'

export const serviceQueryKey = (serviceId: string) => [servicesQueryKey, serviceId]

export const serviceRolesQueryKey = (serviceId: string) => [servicesQueryKey, serviceId, 'roles']
